<div class="painting-page-container" id="painting-page-container">
  <div *ngIf="isLoaderVisible">
    <app-loader></app-loader>
  </div>

  <div class="painting-wrapper" *ngIf="isDataReady">
    <div class="painting">
      <div class="back clickable" (click)="goBack()"><mat-icon>keyboard_arrow_left</mat-icon></div>
      <img [src]="selectedPainting.path" alt="pictura">
      <div class="wave-painting-divider">
        <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 1200" preserveAspectRatio="none">
          <path d="M56.44,321.39c-10.79,58-30.13,114.16-41.86,172-16.72,82.39-17.73,168.19-.39,250.45,17.73,82.39,58.73,165.28,79.56,244.27,18.48,70.05,26.09,146.53,3,214.34H0V0H27.35A600.21,600.21,0,0,1,56.44,321.39Z" class="shape-fill"></path>
        </svg>
      </div>
    </div>
    <div class="painting-details">
      <div *ngIf="isFirstOpen" @fadeAnimation>
        <h1 class="italic bold">
          {{selectedPainting.name | translate}}
        </h1>
        <p class="description italic">{{selectedPainting.description | translate}}</p>

        <p class="details-margin">{{selectedPainting.dimension}}, {{selectedPainting.technique | translate}}</p>


        <div class="long-details-description" *ngIf="lc">
          <p>{{selectedPainting.technique + 'LongDescr' | translate}}</p>
        </div>

        <table *ngIf="lc">
          <tr>
            <td rowspan="3" class="artist-td">Artist</td>
            <td class="artist-details-td"><mat-icon>tag_faces</mat-icon>Andreea Lupu</td>
          </tr>
          <tr>
            <td class="artist-details-td"><mat-icon> email</mat-icon>lupulcreativ&#64;gmail.com</td>
          </tr>
          <tr>
            <td class="artist-details-td"><mat-icon> phone</mat-icon>0740241423</td>
          </tr>
        </table>
        <table *ngIf="!lc">
          <tr>
            <td rowspan="3" class="artist-td">Artist</td>
            <td class="artist-details-td"><mat-icon>tag_faces</mat-icon>
               {{artistName}}</td>
          </tr>
          <tr>
            <td class="artist-details-td"><mat-icon> email</mat-icon> {{artistEmail}}</td>
          </tr>
          <tr>
            <td class="artist-details-td"><mat-icon> phone</mat-icon> {{artistPhone}}</td>
          </tr>
        </table>


        <div class="flex">
          <p *ngIf="selectedPainting.availability === 0" class="italic">{{'available'|translate}} </p>
          <p *ngIf="selectedPainting.availability === 1" class="italic">{{'notAvailable' | translate}}</p>

          <p class="italic bold" *ngIf="selectedPainting.availability === 0 && selectedPainting.price" style="margin-left: 10px">{{selectedPainting.price}} Lei
          </p>
        </div>

        <button mat-raised-button class="contrast-button" *ngIf="selectedPainting.availability === 1 && !isUserArtist" (click)="toggleDivs()">{{'preOrder' | translate}}</button>
        <p style="font-size: 14px" *ngIf="selectedPainting.availability === 1 && !isUserArtist">{{'preorderInfo' | translate}}</p>

        <button mat-raised-button class="contrast-button" *ngIf="selectedPainting.availability === 0 && !isUserArtist" (click)="toggleDivs()">{{'justOrder' | translate}}</button>
      </div>

      <div *ngIf="!isFirstOpen" @fadeAnimation>
        <form [formGroup]="myForm">
          <h1>{{'completeForm' | translate}}</h1>
          <p>{{'orderWillBeConfirmedInfo' | translate}}</p>
          <div class="table full-width">
            <mat-form-field class="half-width">
              <mat-label>{{'orderFormFirstname' | translate}}</mat-label>
              <input matInput [formControl]="firstNameFormControl">
              <mat-error *ngIf="firstNameFormControl.hasError('required')">
                {{'orderFormFirstNameIs' | translate}} <strong>{{'required' | translate}}</strong>
              </mat-error>
            </mat-form-field>
            <mat-form-field class="half-width">
              <mat-label>{{'orderFormLastname' | translate}}</mat-label>
              <input matInput [formControl]="lastNameFormControl">
              <mat-error *ngIf="lastNameFormControl.hasError('required')">
                {{'orderFormLastnameIs' | translate}} <strong>{{'required' | translate}}</strong>
              </mat-error>
            </mat-form-field>
          </div>

          <mat-form-field class="full-width">
            <mat-label>{{'orderFormEmail' | translate}}</mat-label>
            <input type="email" matInput [formControl]="emailFormControl" placeholder="pat@example.com">
            <mat-error *ngIf="emailFormControl.hasError('email') && !emailFormControl.hasError('required')">
              {{'orderFormEmailMustBeValid' | translate}}
            </mat-error>
            <mat-error *ngIf="emailFormControl.hasError('required')">
              {{'orderFormEmailIs' | translate}} <strong>{{'required' | translate}}</strong>
            </mat-error>
          </mat-form-field>

          <mat-form-field class="full-width">
            <mat-label>{{'orderFormTelephone' | translate}}</mat-label>
            <input type="tel" matInput placeholder="0744444444" [formControl]="telephoneFormControl" >
            <mat-error *ngIf="telephoneFormControl.hasError('required')">
              {{'orderFormTelephoneIs' | translate}} <strong>{{'required' | translate}}</strong>
            </mat-error>
            <mat-error *ngIf="telephoneFormControl.hasError('pattern')">
              {{'orderFormTelephoneError' | translate}}
            </mat-error>
          </mat-form-field>

          <mat-form-field class="full-width">
            <mat-label>{{'orderFormMessage' | translate}}</mat-label>
            <textarea matInput placeholder="{{'orderFormMessagePlaceholder' | translate}}." [(ngModel)]="otherDetails" [ngModelOptions]="{standalone: true}"></textarea>
          </mat-form-field>

          <mat-checkbox [formControl]="termsAndConditionsControl" class="full-width" color="primary">{{'agreeWith' | translate}}<a>{{'termsAndConditions' | translate}}</a></mat-checkbox>
          <mat-error *ngIf="termsAndConditionsControl.hasError('required')">
            {{'orderFormFieldIs' | translate}} <strong>{{'required' | translate}}</strong>
          </mat-error>

          <mat-checkbox [formControl]="confidentialityPolicyControl" class="full-width" color="primary">{{'agreeWithDataProcessing'|translate}}</mat-checkbox>
          <mat-error *ngIf="confidentialityPolicyControl.hasError('required')">
            {{'orderFormFieldIs' | translate}} <strong>{{'required' | translate}}</strong>
          </mat-error>

          <p *ngIf="isDataSent" class="success-message full-width">{{'requestSentSuccessfully' | translate}}</p>
        </form>
        <div class="flex flex-center">
          <button mat-raised-button class="contrast-button" (click)="sendOrder()" [disabled]="myForm.invalid || isDataSent">{{'sendOffer' | translate}}</button>
          <button mat-raised-button class="simple-button" (click)="toggleDivs()"  style="margin-left: 10px;">{{'backToGalley' | translate}}</button>

        </div>
      </div>


    </div>
  </div>

  <div class="bottom-gradient"></div>
</div>
